import SaveContentActions from "../shared/SaveContentActions";

const ImageActions = ({
  imageUrl,
  initialImageUrl = null,
  onCallbackSave = () => {},
  onClose,
  showSaveAlert = true,
  disabled,
}) => {
  if (!imageUrl) return null;

  const isOriginalImage = imageUrl === initialImageUrl;
  const isDisabled =
    typeof disabled === "boolean" ? disabled : isOriginalImage;

  return (
    <SaveContentActions
      disabled={isDisabled}
      showSaveAlert={showSaveAlert}
      showDownload
      downloadUrl={imageUrl}
      contentUrl={imageUrl}
      onSave={onCallbackSave}
      onCloseAfterSave={onClose}
    />
  );
};

export default ImageActions;
